namespace $.$$ {
	$mol_style_define( $eve_app, {
		Head: {
			background: {
				color: $eve_surface_get_token_surface_level_var( 'low' ) as any,
			},

		},
	} )
}
